<template>
  <span aria-hidden="true" class="hidden" />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from "vue"
import {
  initializeNativeStoreUpdatePrompt,
  teardownNativeStoreUpdatePrompt
} from "@/mobile_app/services/native-store-update-service"

onMounted(() => {
  void initializeNativeStoreUpdatePrompt()
})

onUnmounted(() => {
  void teardownNativeStoreUpdatePrompt()
})
</script>
